import React, { useEffect } from "react";
import { Text } from "@chakra-ui/react";
import { getTimeDelta, getTimerValue } from "duck";

interface TimerProps {
  startTime: Date | null;
  endTime: Date | null;
}

const Timer: React.FC<TimerProps> = ({ startTime, endTime }) => {
  const [time, setTime] = React.useState(() =>
    getTimeDelta(startTime, endTime)
  );

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;

    if (startTime && !endTime) {
      interval = setInterval(() => {
        setTime(getTimeDelta(startTime, endTime));
      }, 1000);
    }
    if (startTime && endTime) {
      setTime(getTimeDelta(startTime, endTime));
    }

    return () => clearInterval(interval);
  }, [startTime, endTime]);

  useEffect(() => {
    const visibilityChangeHandler = () => {
      if (document.visibilityState === "visible") {
        setTime(getTimeDelta(startTime, endTime));
      }
    };

    document.addEventListener("visibilitychange", visibilityChangeHandler);

    return () => {
      document.removeEventListener("visibilitychange", visibilityChangeHandler);
    };
  }, [startTime]);

  return (
    <>
      <Text>{time ? getTimerValue(time) : "-"}</Text>
    </>
  );
};

export default Timer;
